import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import VueCookies from 'vue-cookies'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userId: "",
    userName: "",
    sessionId: "",
    roleLevel: "",
    code: "",
    status: "",
    inputAchieve: {},
  },
  getters: {
    getSessionId(state) {
      return state.sessionId
    },
    getRoleLevel(state){
      return state.roleLevel
    },
    getUserId(state) {
      return state.userId
    },
    getUserName(state){
      return state.userName
    },
    getCode(state){
      return state.code
    },
    getStatus(state){
      return state.status
    },
    getInputAchieve(state) {
      return state.inputAchieve
    }
  },
  mutations: {
    saveSessionId(state,sessionId) {
      state.sessionId = sessionId
    },
    saveRoleLevel(state,roleLevel) {
      state.roleLevel = roleLevel
    },
    saveUserId(state,userId) {
      state.userId = userId
    },
    saveUserName(state,userName) {
      state.userName = userName
    },
    saveCode(state,code) {
      state.code = code
    },
    saveStatus(state,status) {
      state.status = status
    },
    saveInputAchieve(state, inputAchieve) {
      state.inputAchieve = inputAchieve
    },
    removeSessionId(state){
      state.sessionId = ""
   },
    removeRoleLevel(state){
        state.roleLevel = ""
    },
    removeUserId(state){
      state.userId = ""
    },
    removeUserName(state){
      state.userName = ""
    },
    removeCode(state){
      state.code = ""
    },
    removeStatus(state){
      state.status = ""
    },
    removeInputAchieve(state){
      state.inputAchieve = ""
    },
  },
  actions: {
    saveSessionId({commit}, sessionId){
      commit("saveSessionId", sessionId)
    },
    removeSessionId({commit}){
        commit("removeSessionId")
    },
    saveRoleLevel({commit},roleLevel){
        commit("saveRoleLevel",roleLevel)
    },
    removeRoleLevel({commit}){
        commit("removeRoleLevel")
    },
    saveUserId({commit}, userId){
      commit("saveUserId", userId)
    },
    removeUserId({commit}){
        commit("removeUserId")
    },
    saveUserName({commit}, userName){
      commit("saveUserName", userName)
    },
    removeUserName({commit}){
        commit("removeUserName")
    },
    saveCode({commit}, code){
      commit("saveCode", code)
    },
    removeCode({commit}){
        commit("removeCode")
    },
    saveStatus({commit}, status){
      commit("saveStatus", status)
    },
    removeStatus({commit}){
        commit("removeStatus")
    },
    saveInputAchieve({commit}, inputAchieve){
      commit("saveInputAchieve", inputAchieve)
    },
    removeInputAchieve({commit}){
        commit("removeInputAchieve")
    },
  },
  modules: {
  },
  plugins: [
    createPersistedState({
      storage: {
        getItem: (key) => VueCookies.get(key),
        setItem: (key, value) =>
          VueCookies.set(key, value, {
            expires: 3,
            secure: true,
          }),
        removeItem: (key) => VueCookies.remove(key),
      },
      storage: window.sessionStorage
    }),
  ]
})
